import { trpc } from '@/shared/api/trpc';

// Hotel-typed products with a confirmed HyperGuest mapping — feeds the
// "pick hotels" MultiSelect on the Search tab. The `products.hotels`
// procedure surfaces the `hasHyperGuestId` filter (legacy returns the
// whole array, no pagination).
export const useHotelsWithHyperguest = () =>
  trpc.products.hotels.useQuery({ hasHyperGuestId: true });
